<div class="main-container">
  <div class="referidos-content row">
    <span style="font-size: large">
      Ingrese la información del usuario a consultar
    </span>

    <br />
    <br />

    <form [formGroup]="frmReferidos">
      <div class="form-container row">
        <div class="col-8">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo de identificación</mat-label>
                <mat-select formControlName="tipo_identificacion">
                  <mat-option *ngFor="let t of tipo_id" [value]="t">
                    {{ t }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Número de identificación</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="identificacion"
                  maxlength="20"
                />
                <mat-error *ngIf="hasError(getControl['identificacion'])">
                  {{
                    printError(getControl["identificacion"], {
                      noSpaces: "No se permite espacios"
                    })
                  }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Referidos</mat-label>
                <mat-select formControlName="referidos">
                  <mat-option *ngFor="let r of referidos" [value]="r">
                    {{ r }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field
                appearance="outline"
                style="width: 100%"
                floatLabel="always"
              >
                <mat-label>Fecha de notificación</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  placeholder="YYYY/MM/DD"
                  formControlName="fecha_creacion"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field
                appearance="outline"
                style="width: 100%"
                floatLabel="always"
              >
                <mat-label>Fecha de gestión</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  placeholder="YYYY/MM/DD"
                  formControlName="fecha_ultima_gestion"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <button
                type="submit"
                class="btn btn-primary btn-icon"
                (click)="consultar()"
                appTrackClick
                [trackData]="trackDataCarnet"
              >
                <mat-icon>search</mat-icon><span>CONSULTAR</span>
              </button>
            </div>

            <div class="col-12 col-md-6 col-lg-5">
              <button
                type="button"
                class="btn btn-primary btn-icon"
                (click)="clear()"
              >
                <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div>
      <div
        *ngIf="haveResponde"
        class="mat-elevation-z8 col-12"
        style="display: flex; flex-direction: column; min-width: 300px"
      >
        <mat-table [dataSource]="dsReferidos" matSort>
          <ng-container
            *ngFor="let dt of attrData; let i = index"
            [matColumnDef]="dt"
          >
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ namesColumns[i] }}
            </mat-header-cell>

            <mat-cell *matCellDef="let element">
              {{ element[dt] }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="attrData"></mat-header-row>
          <mat-row *matRowDef="let row; columns: attrData"></mat-row>
        </mat-table>

        <mat-paginator
         *ngIf="haveDataToShow"
          [pageSize]="15"
          [pageSizeOptions]="[15, 20, 30]"
          [showFirstLastButtons]="true"
        ></mat-paginator>

        <br />
        <div style="text-align: center" *ngIf="!haveDataToShow">
          <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
        </div>
      </div>

      <div *ngIf="!haveResponde" class="message-container">
        <span class="message-span">{{ generalMessage.toUpperCase() }}</span>
      </div>
    </div>
  </div>
</div>
